var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffQ111(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.6,
    height: 50.2,
    viewBox: "0 0 63.6 50.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.848,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ed3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5,
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 5.202,
    height: 2.952,
    transform: "translate(22.541 41.325)",
    fill: "#e2e4e5",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.2,0H29.433a1.2,1.2,0,0,1,1.2,1.2V47.8a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,47.8V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(27.743)",
    fill: "#e2e4e5",
    stroke: "#e2e4e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M1.2,0H21.341a1.2,1.2,0,0,1,1.2,1.2V22.414a1.2,1.2,0,0,1-1.2,1.2H1.2a1.2,1.2,0,0,1-1.2-1.2V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(0 25.386)",
    fill: "#e2e4e5",
    stroke: "#e2e4e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 24.275,
    height: 40.145,
    rx: 1.2,
    transform: "translate(31.211 5.313)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 17.917,
    height: 18.892,
    rx: 1.2,
    transform: "translate(2.312 27.747)",
    fill: "#fff",
    stroke: "#e2e3e4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M27.963,20.142H0v-2.5H27.963a.959.959,0,0,0,0-1.915H11.631a3.548,3.548,0,0,1,0-7.1H27.608a1.321,1.321,0,0,0,0-2.64H11.7A3.6,3.6,0,0,1,8.131,2.37,3.6,3.6,0,0,1,11.7-1.25H39.3v2.5H11.7a1.1,1.1,0,0,0-1.071,1.12A1.1,1.1,0,0,0,11.7,3.491H27.608a3.82,3.82,0,0,1,0,7.64H11.631a1.049,1.049,0,0,0,0,2.1H27.963a3.458,3.458,0,0,1,0,6.915Z",
    transform: "translate(23.697 8.855)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.3,12.87h0a.368.368,0,0,1-.26-.11h0L3.335,10l-2.7,2.762a.364.364,0,0,1-.4.082A.378.378,0,0,1,0,12.493V6.443a.389.389,0,0,1,.107-.274L2.8,3.395.108.643A.384.384,0,0,1,.028.233.37.37,0,0,1,.369,0H6.294a.4.4,0,0,1,.267.111l2.7,2.762L11.97.111a.363.363,0,0,1,.4-.082A.378.378,0,0,1,12.6.377V6.429a.387.387,0,0,1-.108.273l-2.7,2.762,2.7,2.762a.382.382,0,0,1,.08.411.368.368,0,0,1-.341.233Z",
    transform: "translate(5.202 30.699)",
    fill: "#e2e4e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffQ111);
export default __webpack_public_path__ + "static/media/off_Q1_11_.5471b96cfc3c1d1e70f120b0a598aded.svg";
export { ForwardRef as ReactComponent };